import standardIcon from './assets/standard.webp';
import silverIcon from './assets/silver.webp';
import goldIcon from './assets/gold.webp';
import platinumIcon from './assets/platinum.webp';

export const TOURS_LIMIT_PER_TRANSACTION = 100_000;

export const CASHBACK_LEVELS = [
  { name: 'Standard', icon: standardIcon, balance: 0.1, cashback: 5 },
  { name: 'Silver', icon: silverIcon, balance: 100_001, cashback: 7 },
  { name: 'Gold', icon: goldIcon, balance: 300_001, cashback: 8 },
  { name: 'Platinum', icon: platinumIcon, balance: 1_000_001, cashback: 10 },
];
